import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MetodosgenService } from '../../services/metodosgen.service';

export interface InfoSection {
    title: string;
    items: InfoItem[];
}

export interface InfoItem {
    label: string;
    value: string | number;
    icon?: string;
    iconColor?: string;
    valueClass?: string;
    rowClass?: string;
    sublabel?: string;
    extraData?: any;
    expanded?: boolean;
}

@Component({
    selector: 'app-infomodal',
    templateUrl: './infomodal.component.html',
    styleUrls: ['./infomodal.component.scss'],
    standalone: false
})
export class InfomodalComponent implements OnInit {

    @Input() title: string = 'Información';
    @Input() subtitle: string = '';
    @Input() sections: InfoSection[] = [];

    @ViewChild('exportArea') exportAreaRef?: ElementRef;

    exporting: boolean = false;

    constructor(
        private modalCtrl: ModalController,
        private metodosGenService: MetodosgenService
    ) { }

    ngOnInit() { }

    dismiss() {
        this.modalCtrl.dismiss();
    }

    getSummary(value: any): string {
        if (!value) return '';
        return String(value);
    }

    /**
     * Pasa la referencia directa del nodo del DOM a MetodosgenService
     * evitando errores de clonación en el iframe de html2canvas.
     */
    async compartirResumenComoImagen() {
        if (this.exporting) return;
        this.exporting = true;
        try {
            const targetEl = this.exportAreaRef?.nativeElement || document.getElementById('export-area');
            await this.metodosGenService.exportarElementoComoImagen(targetEl, this.title, this.subtitle);
        } finally {
            this.exporting = false;
        }
    }
}
